import { render, staticRenderFns } from "./ClassStudentDetail.vue?vue&type=template&id=523d5b2c&scoped=true&"
import script from "./ClassStudentDetail.vue?vue&type=script&lang=js&"
export * from "./ClassStudentDetail.vue?vue&type=script&lang=js&"
import style0 from "./ClassStudentDetail.vue?vue&type=style&index=0&id=523d5b2c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523d5b2c",
  null
  
)

export default component.exports